import { Badge } from "@/view/components/ui/badge"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/view/components/ui/table"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/view/components/ui/tooltip"
import { useToast } from "@/view/hooks"
import { convertDateDisplayFormat } from "@/view/utils/formatDateDisplay"
import { Info, Loader2, Send } from "lucide-react"
import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { useRemoteClientGet, useRemoteClientPost } from "../../../configs/http-client"
import { CatchMessageError } from "../../../remote/catch-message-error"
import { CardInfoSelectMember } from "../../components/card-info-select-member"
import { convertParamsToJson, useCashfitParams } from "../../hooks/use-params"
import { ButtonPdfContract } from "./button-print-contract"

export default function Component({
  id,
  idUnidade,
}: { id: string | undefined | null; idUnidade: number | string | undefined | null }) {
  const { remoteClientGet } = useRemoteClientGet()
  const { httpClientPost } = useRemoteClientPost()
  const [data, setData] = useState<any>([])
  const [loading, setLoading] = useState(false)
  const [params] = useSearchParams()
  const { setParams } = useCashfitParams(convertParamsToJson(params))
  const { showToast } = useToast()
  const [loadinSendEmail, setLoadingSendEmail] = useState(false)

  useEffect(() => {
    if (id && !loading) {
      setLoading(true)
      remoteClientGet(`/vendas/contratos/aluno/${id}?idUnidade=${idUnidade}`)
        .then((response) => {
          console.log("Debug")
          // Updated to handle the new response structure
          const data = response?.data?.data ?? []
          console.log("Data", data)
          setData(data)
        })
        .catch(CatchMessageError)
        .finally(() => {
          setLoading(false)
        })
    }
  }, [id])

  const backToStudents = () => setParams({ tabSelected: "studants" as any })

  const sendEmail = (idPagamento: string | number, origem: string) => {
    if (!loadinSendEmail) {
      setLoadingSendEmail(true)
      httpClientPost(`/pagamentos/webhook/reenviarEmail`, {
        idPagamento,
        origem,
      })
        .then((response) => {
          console.log("Email enviado com sucesso", response)
          showToast("Email enviado com sucesso", "success")
        })
        .catch((error) => {
          console.error("Erro ao enviar email", error)
          showToast("Erro ao enviar email", "error")
        })
        .finally(() => setLoadingSendEmail(false))
    }
  }

  const getStatusBadge = (statusPlano: number) => {
    switch (statusPlano) {
      case 1:
        return { variant: "default" as const, text: "Ativo" }
      case 0:
        return { variant: "destructive" as const, text: "Inativo" }
      default:
        return { variant: "secondary" as const, text: "Desconhecido" }
    }
  }

  if (!params.get("tabContentId")) return <CardInfoSelectMember backToStudents={backToStudents} />

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-medium flex items-center gap-2">
          CONTRATOS
          <span className="text-sm text-muted-foreground"></span>
        </h2>
      </div>

      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>PLANO</TableHead>
              <TableHead>CONTRATO</TableHead>
              {/* <TableHead>ALUNO</TableHead> */}
              <TableHead>INÍCIO</TableHead>
              <TableHead>VENCIMENTO</TableHead>
              {/* <TableHead>ID VENDA</TableHead> */}
              <TableHead>STATUS</TableHead>
              <TableHead className="text-right">AÇÕES</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={8} className="text-center py-8">
                  <Loader2 className="h-6 w-6 animate-spin mx-auto" />
                  <p className="text-sm text-muted-foreground mt-2">Carregando contratos...</p>
                </TableCell>
              </TableRow>
            ) : data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} className="text-center py-8">
                  <p className="text-sm text-muted-foreground">Nenhum contrato encontrado</p>
                </TableCell>
              </TableRow>
            ) : (
              data.map((item: any) =>
                item.contratos && item.contratos.length > 0 ? (
                  item.contratos.map((contrato: any, index: number) => (
                    <TableRow key={`${item.idVenda}-${contrato.id}-${index}`}>
                      <TableCell>
                        <div className="space-y-1">
                          <div className="font-medium">{item.nomePlano}</div>
                          <div className="text-xs text-muted-foreground">Plano ID: {item.idPlano}</div>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className="space-y-1">
                          <div className="font-medium">{contrato.nome}</div>
                          <div className="text-xs text-muted-foreground">Contrato ID: {contrato.id}</div>
                        </div>
                      </TableCell>
                      {/* <TableCell>
                        <HoverCard>
                          <HoverCardTrigger asChild>
                            <div className="flex items-center gap-1 cursor-help">
                              <span>Aluno ID: {item.idAluno}</span>
                              <Info className="h-4 w-4 text-muted-foreground" />
                            </div>
                          </HoverCardTrigger>
                          <HoverCardContent className="w-80">
                            <div className="space-y-2">
                              <h4 className="text-sm font-semibold">Detalhes do Aluno</h4>
                              <div className="space-y-1 text-sm">
                                <p>
                                  <strong>ID Aluno:</strong> {item.idAluno}
                                </p>
                                <p>
                                  <strong>ID Contrato:</strong> {contrato.id}
                                </p>
                                <p>
                                  <strong>ID Academia:</strong> {contrato.idAcademia}
                                </p>
                                <p>
                                  <strong>Contrato Original:</strong> {contrato.idContratoOriginal}
                                </p>
                              </div>
                            </div>
                          </HoverCardContent>
                        </HoverCard>
                      </TableCell> */}
                      <TableCell>
                        <div className="space-y-1">
                          <div>
                            {contrato.dataInicio
                              ? convertDateDisplayFormat(contrato.dataInicio.split("T")[0])
                              : "Sem Início"}
                          </div>
                          <div className="text-xs text-muted-foreground">
                            Plano:{" "}
                            {item.dataInicioPlano
                              ? convertDateDisplayFormat(item.dataInicioPlano.split("T")[0])
                              : "N/A"}
                          </div>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className="space-y-1">
                          <div>
                            {contrato.dataVencimento
                              ? convertDateDisplayFormat(contrato.dataVencimento.split("T")[0])
                              : "Sem Validade"}
                          </div>
                          <div className="text-xs text-muted-foreground">
                            Plano:{" "}
                            {item.dataVencimentoPlano
                              ? convertDateDisplayFormat(item.dataVencimentoPlano.split("T")[0])
                              : "N/A"}
                          </div>
                        </div>
                      </TableCell>
                      {/* <TableCell>
                        <div className="space-y-1">
                          <div className="font-medium">{item.idVenda}</div>
                          <div className="text-xs text-muted-foreground">{item.origem}</div>
                        </div>
                      </TableCell> */}
                      <TableCell>
                        <div className="space-y-1">
                          <Badge variant={getStatusBadge(item.statusPlano).variant} className="font-normal">
                            {getStatusBadge(item.statusPlano).text}
                          </Badge>
                          {/* <div className="text-xs text-muted-foreground">Pagamento ID: {item.idPagamento}</div> */}
                        </div>
                      </TableCell>
                      <TableCell>
                        <TooltipProvider>
                          <div className="flex justify-start gap-2 items-center">
                            {item.idPlano && (
                              <>
                                <Tooltip>
                                  <TooltipTrigger asChild>
                                    <ButtonPdfContract idPlano={item.idPlano} idAluno={item.idAluno} />
                                  </TooltipTrigger>
                                  <TooltipContent>Imprimir Contrato</TooltipContent>
                                </Tooltip>

                                <Tooltip>
                                  <TooltipTrigger asChild>
                                    <div className="p-2 rounded-md hover:bg-slate-100">
                                      <Info
                                        className="h-4 w-4 hover:cursor-pointer"
                                        onClick={() => setParams({ tabPlanId: item.idPlano })}
                                      />
                                    </div>
                                  </TooltipTrigger>
                                  <TooltipContent>Atualizar Datas</TooltipContent>
                                </Tooltip>
                              </>
                            )}

                            <Tooltip>
                              <TooltipTrigger asChild>
                                <div className="p-2 rounded-md hover:bg-slate-100">
                                  {loadinSendEmail ? (
                                    <Loader2 className="h-4 w-4 animate-spin" />
                                  ) : (
                                    <Send
                                      className="h-4 w-4 hover:cursor-pointer"
                                      onClick={() => sendEmail(item.idPagamento, item.origem)}
                                    />
                                  )}
                                </div>
                              </TooltipTrigger>
                              <TooltipContent>Enviar Email</TooltipContent>
                            </Tooltip>
                          </div>
                        </TooltipProvider>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow key={`${item.idVenda}-no-contracts`}>
                    <TableCell>
                      <div className="space-y-1">
                        <div className="font-medium">{item.nomePlano}</div>
                        <div className="text-xs text-muted-foreground">Plano ID: {item.idPlano}</div>
                      </div>
                    </TableCell>
                    <TableCell colSpan={2}>
                      <span className="text-muted-foreground italic">Sem contratos associados</span>
                    </TableCell>
                    <TableCell>
                      {item.dataInicioPlano ? convertDateDisplayFormat(item.dataInicioPlano.split("T")[0]) : "N/A"}
                    </TableCell>
                    <TableCell>
                      {item.dataVencimentoPlano
                        ? convertDateDisplayFormat(item.dataVencimentoPlano.split("T")[0])
                        : "N/A"}
                    </TableCell>
                    <TableCell>
                      <div className="space-y-1">
                        <div className="font-medium">{item.idVenda}</div>
                        <div className="text-xs text-muted-foreground">{item.origem}</div>
                      </div>
                    </TableCell>
                    <TableCell>
                      <Badge variant={getStatusBadge(item.statusPlano).variant} className="font-normal">
                        {getStatusBadge(item.statusPlano).text}
                      </Badge>
                    </TableCell>
                    <TableCell>
                      <TooltipProvider>
                        <div className="flex justify-start gap-2 items-center">
                          <Tooltip>
                            <TooltipTrigger asChild>
                              <div className="p-2 rounded-md hover:bg-slate-100">
                                {loadinSendEmail ? (
                                  <Loader2 className="h-4 w-4 animate-spin" />
                                ) : (
                                  <Send
                                    className="h-4 w-4 hover:cursor-pointer"
                                    onClick={() => sendEmail(item.idPagamento, item.origem)}
                                  />
                                )}
                              </div>
                            </TooltipTrigger>
                            <TooltipContent>Enviar Email</TooltipContent>
                          </Tooltip>
                        </div>
                      </TooltipProvider>
                    </TableCell>
                  </TableRow>
                ),
              )
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}
